var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-gray2"},[_vm._v(" splash ")])
}
var staticRenderFns = []

export { render, staticRenderFns }